import React, { useState, useMemo, Fragment, memo, useEffect } from "react";
import _, { isArray } from "lodash";
import { useTable, useRowSelect } from "react-table";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import classNames from "classnames";
import { format, differenceInDays } from "date-fns";
import Swal from "sweetalert2";
import {
  faAngleUp,
  faAngleDown,
  faCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// OTHER
import numeral from "numeral";
import {
  pdf,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { ToastContainer, toast } from "react-toastify";
import { saveAs } from "file-saver";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import font from "../../styles/Sarabun-Regular.ttf";
import fontBold from "../../styles/Sarabun-Bold.ttf";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";

const IndeterminateCheckbox = React.forwardRef(
  ({ onChange, id, selectedFlatRows, flatRows, ...rest }, ref) => {
    useEffect(() => {
      const getIdAll = document.getElementById("ALL");
      if (selectedFlatRows?.length > 0) {
        const newRows = flatRows
          .map((row) => {
            return row;
          })
          .filter((row) => row);
        getIdAll.checked = newRows.length === selectedFlatRows.length;
        getIdAll.indeterminate = newRows.length !== selectedFlatRows.length;
        return;
      }
      getIdAll.indeterminate = false;
      getIdAll.checked = false;
    }, [selectedFlatRows]);

    return (
      <>
        <input
          type="checkbox"
          id={id}
          onChange={onChange}
          {...rest}
          style={{ width: "20px", height: "20px" }}
        />
      </>
    );
  }
);

Font.register({ family: "Sarabun", fonts: [{ src: font }, { src: fontBold }] });

const styles = StyleSheet.create({
  page: {
    fontFamily: "Sarabun",
    padding: 26,
    fontSize: 12,
    backgroundColor: "#fff",
  },
  bold: {
    fontFamily: "Sarabun",
    fontWeight: "bold",
  },
  date: {
    textAlign: "right",
  },
  newLine: {
    marginTop: 32,
  },
  marginLeft: {
    marginLeft: 20,
  },
  betweenLine: {
    marginTop: 4,
  },
  header: {
    fontSize: 11,
    textAlign: "center",
  },
  red: {
    color: "red",
  },
  end: {
    textAlign: "right",
    marginRight: 32,
  },
  signature: {
    textAlign: "right",
    marginRight: 16,
    fontWeight: "bold",
  },
});

const PdfDocument = ({
  name = "นาย พนิต จ๋วงพานิช",
  letter_id,
  isFirst = false,
}) => {
  var now_th = moment.locale("th");
  var today = moment().add(543, "year").format("DD/MM/YYYY");
  var currentYear = moment().add(543, "year").year();
  var rawMonth = moment().format("MM");
  var currentMonth = "มกราคม";
  if (rawMonth == "02") currentMonth = "กุมภาพันธ์";
  if (rawMonth == "03") currentMonth = "มีนาคม";
  if (rawMonth == "04") currentMonth = "เมษายน";
  if (rawMonth == "05") currentMonth = "พฤษภาคม";
  if (rawMonth == "06") currentMonth = "มิถุนายน";
  if (rawMonth == "07") currentMonth = "กรกฎาคม";
  if (rawMonth == "08") currentMonth = "สิงหาคม";
  if (rawMonth == "09") currentMonth = "กันยายน";
  if (rawMonth == "10") currentMonth = "ตุลาคม";
  if (rawMonth == "11") currentMonth = "พฤศจิกายน";
  if (rawMonth == "12") currentMonth = "ธันวาคม";

  var previousYear = Number(currentYear) - 1;
  var header = "หนังสือแจ้งรายปีฉบับที่";
  if (isFirst) {
    header = "หนังสือแจ้งครั้งแรกฉบับที่";
  }
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.header}>
          หนังสือแจ้งให้ลูกค้าทราบเกี่ยวกับการส่งข้อมูลให้แก่บริษัทข้อมูลเครดิต
          ({header}{" "}
          {(new Date().getFullYear() + 543).toString() + "/" + letter_id})
        </Text>
        <View style={styles.betweenLine}></View>
        <View style={styles.betweenLine}></View>
        <Text style={styles.date}>วันที่ {today}</Text>
        <View style={styles.betweenLine}></View>
        <Text>เรียน คุณ {name}</Text>
        <View style={styles.newLine}></View>
        <Text style={styles.marginLeft}>
          ตามพระราชบัญญัติการประกอบธุรกิจขอมูลเครดิต พ.ศ. 2545
          และที่แก้ไขเพิ่มเติม และประกาศคณะกรรมการ
        </Text>
        <View style={styles.betweenLine}></View>
        <Text>
          คุ้มครองข้อมูลเครดิต กำหนดไว้{" "}
          <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          มีหน้าที่ต้องส่งข้อมูลเครดิตของท่านให้แก่ บริษัท
        </Text>
        <View style={styles.betweenLine}></View>
        <Text>
          ข้อมูลเครดิตแห่งชาติ จำกัด ที่{" "}
          <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          เป็นสมาชิกอยู่ และแจ้งให้ท่านทราบเกี่ยวกับข้อมูล
        </Text>
        <View style={styles.betweenLine}></View>
        <Text>
          เครดิตที่ส่งไป ดังกล่าว ดังนั้น
          เพื่อดำเนินการให้เป็นไปตามบทบัญญัติของพระราชบัญญัติ ตลอดจนประกาศคณะ{" "}
        </Text>
        <View style={styles.betweenLine}></View>
        {!isFirst && (
          <View>
            <Text>
              กรรมการคุ้มครอง ข้อมูลเครดิตข้างต้น{" "}
              <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด </Text>
              จึงขอแจ้งให้ท่านทราบว่า ในรอบปี ({currentYear}/
            </Text>
            <View style={styles.betweenLine}></View>
            <Text>
              {previousYear}) ที่ผ่านมา ได้ส่ง ข้อมูลเครดิตของท่าน ให้แก่ บริษัท
              ข้อมูลเครดิตแห่งชาติ จำกัด แล้วโดยข้อมูลเครดิตที่{" "}
            </Text>
            <View style={styles.betweenLine}></View>
            <Text>
              <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด </Text>
              ส่งไปดังกล่าว มีรายละเอียด ปรากฎท้ายหนังสือนี้{" "}
            </Text>
          </View>
        )}
        {isFirst && (
          <View>
            <Text>
              กรรมการคุ้มครอง ข้อมูลเครดิตข้างต้น{" "}
              <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด </Text>
              จึงขอแจ้งให้ท่านทราบว่า ใน{" "}
              <Text style={styles.bold}>เดือน {currentMonth}</Text>
            </Text>
            <View style={styles.betweenLine}></View>
            <Text>
              <Text style={styles.bold}>
                ปี {currentYear} บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
              </Text>{" "}
              ได้ส่งข้อมูลเครดิตของท่าน ณ{" "}
              <Text style={styles.bold}>
                เดือน {currentMonth} ปี {currentYear}
              </Text>{" "}
              ให้แก่ บริษัท
            </Text>
            <View style={styles.betweenLine}></View>
            <Text>
              ข้อมูลเครดิตแห่งชาติ จำกัด แล้ว โดยข้อมูลเครดิตที่{" "}
              <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>
              {isFirst ? " ส่งไปดังกล่าว มีรายละเอียด" : ""}
            </Text>
            <View style={styles.betweenLine}></View>
            <Text> ส่งไปดังกล่าว มีรายละเอียด ปรากฎท้ายหนังสือนี้ </Text>
          </View>
        )}

        <View style={styles.betweenLine}></View>
        <View style={styles.betweenLine}></View>
        <View style={styles.betweenLine}></View>
        <View style={styles.betweenLine}></View>
        <View style={styles.betweenLine}></View>
        <Text style={styles.marginLeft}>
          {" "}
          ทั้งนี้ ข้อมูลเครดิตที่{" "}
          <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          นำส่งให้แก่ บริษัท ข้อมูลเครดิตแห่งชาติ จำกัด{" "}
        </Text>
        <View style={styles.betweenLine}></View>
        <Text>
          ดังกล่าว{" "}
          <Text style={styles.red}>
            {isFirst
              ? "แสดงรายละเอียดการชำระสินเชื่อ"
              : "ประวัติการชำระสินเชื่อ"}
          </Text>{" "}
          ที่ท่านมีกับ{" "}
          <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          เพียงสถานะล่าสุดในขณะที่{" "}
        </Text>
        <View style={styles.betweenLine}></View>
        <Text>
          <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          จัดทำข้อมูลเพื่อนำส่งข้อมูลเครดิตให้แก่ บริษัท ข้อมูลเครดิตแห่งชาติ
          จำกัด{" "}
        </Text>
        <View style={styles.betweenLine}></View>
        <Text>
          ดังกล่าวเท่านั้น ซึ่งข้อมูลเครดิตดังกล่าวอาจแตกต่างจากข้อมูลที่{" "}
          <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          มีอยู่ในขณะนี้
        </Text>
        <View style={styles.newLine}></View>

        <Text style={styles.marginLeft}>
          จึงเรียนมาเพื่อโปรดทราบ หากท่านมีข้อสงสัย หรือข้อสอบถาม โปรด
        </Text>
        <View style={styles.betweenLine}></View>
        <Text>
          ติดต่อ{" "}
          <Text style={styles.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          โทรศัพท์ 02-791-1300
        </Text>
        <View style={styles.newLine}></View>
        <Text style={styles.end}>ขอแสดงความนับถือ</Text>
        <View style={styles.betweenLine}></View>
        <View style={styles.betweenLine}></View>
        <Text style={styles.signature}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>
      </Page>
    </Document>
  );
};

var isProcessing = false;

const generatePdfDocument = async (
  name = "นาย พนิต จ๋วงพานิช",
  isFirst = false,
  filename
) => {
  if (isProcessing) toast.warn("กำลังทำรายการโปรดรอสักครู่");
  else isProcessing = true;
  /// Cal increment Lamba to get Count here
  try {
    const count = await API.put("MoneyHubAdmin", `/letterCount`, {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
      body: {},
    });
    const blob = await pdf(
      <PdfDocument
        title={filename}
        name={name}
        letter_id={count}
        isFirst={isFirst}
      />
    ).toBlob();
    saveAs(blob, filename);
    toast.success("ดาวโหลดสมบูรณ์");
    isProcessing = false;
  } catch (error) {
    alert(error);
    isProcessing = false;
  }
};

const Row = memo(({ row, i, value, getData, query, paid_date }) => {
  const { user } = useSelector((state) => state.initializeApp);
  return (
    <Fragment>
      <tr
        {...row.getRowProps()}
        className={classNames(
          "cursor-pointer hover:bg-blueGray-200 transition-all duration-300",
          {
            "bg-white": i % 2 === 0,
            "bg-gray-100": i % 2 !== 0,
          }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              className={"p-4 text-gray-700 text-sm text-center"}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
    </Fragment>
  );
});

function BuroTable({ data, getData, query, overDueDate, setSelectedRows }) {
  const columns = useMemo(
    () => [
      {
        Header: "Job. No.",
        accessor: "loan_kbank_id",
      },
      {
        Header: "EMS Year",
        accessor: "ems_year",
      },
      {
        Header: "EMS Initial",
        accessor: "ems_initial",
      },
      {
        Header: "ชื่อ",
        accessor: "fullname",
      },
      {
        Header: "จำนวนงวด",
        accessor: "period",
      },
      {
        Header: "ประเภทสินเชื่อ",
        accessor: "type",
      },
      {
        Header: "เงินทุน",
        accessor: "initCapital",
        Cell: ({ row }) => {
          return <div>{numeral(row.values.initCapital).format("0,0.00")}</div>;
        },
      },

      {
        Header: "เบอร์โทร",
        accessor: "phone_number",
      },
      {
        Header: "วันที่สร้าง",
        accessor: "requestTime",
        Cell: ({ row }) => {
          return (
            <div>{format(new Date(row.values.requestTime), "dd-MM-yyyy")}</div>
          );
        },
      },
      {
        Header: "แก้ไขโดย",
        accessor: "adminName",
      },
      {
        Header: "BuroDate",
        accessor: "buroDate",
        Cell: ({ row }) => {
          const original = row.original;

          if (!original.buroDate) return <div>-</div>;

          return <div>{format(new Date(original.buroDate), "dd-MM-yyyy")}</div>;
        },
      },
      // {
      //   Header: "จดหมาย",
      //   accessor: "",
      //   Cell: ({ row }) => {
      //     return (
      //       <div className="grid grid-cols-2 gap-1">
      //         <button
      //           className="bg-blue-400 text-white  rounded-md p-1"
      //           onClick={() =>
      //             generatePdfDocument(
      //               row.values.fullname,
      //               false,
      //               row.values.loan_id + "_year.pdf"
      //             )
      //           }
      //         >
      //           รายปี
      //         </button>
      //         <button
      //           className="bg-gray-200 text-gray-700  rounded-md p-1"
      //           onClick={() =>
      //             generatePdfDocument(
      //               row.values.fullname,
      //               true,
      //               row.values.loan_id + "_initial.pdf"
      //             )
      //           }
      //         >
      //           ครั้งแรก
      //         </button>
      //       </div>
      //     );
      //   },
      // },

      /*
          {
            Header: "OverDueDate",
            accessor: "overdue_date",
            Cell: ({ row }) => {
              const { overdue_date, loan_status } = row.values;
    
              const currentOverdue_date = getCurrentLocalDateTime(
                new Date(overdue_date)
              );
    
              const today = getCurrentLocalDateTime(new Date(overDueDate));
    
              const checkOverDueDate =
                currentOverdue_date.fullDate <= today.fullDate &&
                loan_status === "ACTIVE";
    
              return (
                <div
                  className={classNames({
                    "text-red-500": checkOverDueDate,
                  })}
                >
                  {format(new Date(row.values.overdue_date), "dd-MM-yyyy")}
                </div>
              );
            },
          },
          /*
          {
            Header: "OverDueDays",
            accessor: "overdue_date2",
            Cell: ({ row }) => {
              const { overdue_date, loan_status } = row.values;
    
              const currentOverdue_date = getCurrentLocalDateTime(
                new Date(overdue_date)
              );
    
              const today = getCurrentLocalDateTime(new Date(overDueDate));
    
              const checkOverDueDate =
                currentOverdue_date.fullDate <= today.fullDate &&
                loan_status === "ACTIVE";
    
              return (
                <div
                  className={classNames({
                    "text-red-500": checkOverDueDate,
                  })}
                >
                  {checkOverDueDate
                    ? `เกินกำหนด ${differenceInDays(
                        today.timestamp,
                        currentOverdue_date.timestamp
                      )} วัน`
                    : "-"}
                </div>
              );
            },
          },*/
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable({ columns, data }, useRowSelect, (hooks) => {
    hooks.visibleColumns.push((columns) => [
      {
        id: "selection",
        Header: ({
          flatRows,
          getToggleAllRowsSelectedProps,
          toggleRowSelected,
          rows,
          ...props
        }) => {
          const onChangeAll = (e) => {
            flatRows.forEach((row) => {
              const { loan_status, fileBuro } = row.original;
              toggleRowSelected(row.id, e.target.checked);
            });
          };

          return (
            <div>
              <IndeterminateCheckbox
                onChange={onChangeAll}
                flatRows={flatRows}
                id="ALL"
              />
            </div>
          );
        },
        Cell: ({
          row,
          toggleRowSelected,
          selectedFlatRows,
          flatRows,
          ...props
        }) => {
          return (
            <div className="pointer-events-auto cursor-pointer">
              <IndeterminateCheckbox
                selectedFlatRows={selectedFlatRows}
                flatRows={flatRows}
                onClick={(e) => e.stopPropagation()}
                {...row.getToggleRowSelectedProps()}
              />
            </div>
          );
        },
      },
      ...columns,
    ]);
  });

  useEffect(() => {
    setSelectedRows(selectedFlatRows);
  }, [selectedFlatRows]);

  return (
    <div className="mx-4 mb-2">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
      />
      <div className="bg-white rounded border border-gray-300 w-full overflow-x-auto ">
        <table {...getTableProps()} className="w-full whitespace-no-wrap">
          <thead className=" text-sm font-semibold tracking-wide text-gray-500  border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    {...column.getHeaderProps()}
                    className={classNames("px-4 py-3 text-center", {
                      "rounded-tl": i === 0,
                      "rounded-tr": i === headerGroup.headers.length - 1,
                    })}
                  >
                    {column.render("Header")}
                    <span>
                      {" "}
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FontAwesomeIcon icon={faAngleDown} />
                        ) : (
                          <FontAwesomeIcon icon={faAngleUp} />
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
            {...getTableBodyProps()}
          >
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <Row
                  query={query}
                  key={row.getRowProps().key}
                  i={i}
                  row={row}
                  value={data[i]}
                  getData={getData}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default BuroTable;
